<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class="mb mx">
  <div class="row">
    <div class="card m-none full-width">
      <form [formGroup]="form">

        <well-address-picker
          formControlName="addressDTO"
          [validateForDistance]="validateForDistance"
          [displayTypeField]="displayTypeField"
          [displayVisibilityField]="displayVisibilityField"
          [searchLocal]="searchLocal"
          [searchOnGoolge]="searchOnGoolge"
          [meta]="meta"
          [displayAddressTemplateSave]="displayAddressTemplateSave"
          [disableFieldsUntilInput]="disableFieldsUntilInput"
          [hideFieldsUntilInput]="hideFieldsUntilInput"
          [mapFloatRight]="mapFloatRight"
          [mapHeight]="mapHeight"
          [displayAsString]="displayAsString"
          [editString]="editString"
          [handoverAddress]="handoverAddress"
          [showAddressLabel]="showAddressLabel" data-testid="address-dto-picker">
        </well-address-picker>

        <span class="color-danger" *ngIf="form.controls['addressDTO'].errors?.noAddressSelected &&
            form.controls['addressDTO'].dirty &&
            form.controls['addressDTO'].touched
        "> {{'address.error.noAddressSelected' | translate}} </span>
      </form>

      <div class="row">
        <div class="d-flex flex-row justify-end">
          <button pButton [label]="'address.utils.save' | translate" type="submit"
                  (click)="onSubmit()" data-testid="on-submit-btn"></button>
        </div>
      </div>
    </div>
  </div>
</div>


